import * as constants from '../constants/trainees'

const defaultState = {
  trainees: [],
  trainee: {},
  requestType: '',
  requestSuccess: false,
  duplicates: [],
  showDuplicateTraineeWarning: false,
  duplicateTraineeMethod: ''
}

export default (state = defaultState, action) => {
  var newState = {...state}

  switch (action.type){
    case constants.GET_TRAINEES_REQUEST:
      newState.requestType = constants.GET_TRAINEES_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_TRAINEES_SUCCESS:
      newState.requestType = action.type;
      newState.trainees = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.GET_TRAINEES_FAILURE:
      newState = defaultState;
      return newState;
    case constants.ADD_TRAINEE_REQUEST:
      newState.requestType = constants.ADD_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.ADD_TRAINEE_SUCCESS:
      newState.requestType = action.type;
      newState.trainee = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.ADD_TRAINEE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.SHOW_DUPLICATE_TRAINEE_WARNING:
      newState.requestType = action.type;
      newState.duplicates = action.duplicates;
      newState.duplicateTraineeMethod = action.duplicateTraineeMethod;
      newState.showDuplicateTraineeWarning = true;
      newState.trainee = action.trainee;
      newState.requestSuccess = true;
      return newState;
    case constants.ADD_DUPLICATE_TRAINEE_REQUEST:
      newState.requestType = constants.ADD_DUPLICATE_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.ADD_DUPLICATE_TRAINEE_SUCCESS:
      newState.requestType = action.type;
      newState.trainee = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.ADD_DUPLICATE_TRAINEE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.UPDATE_TRAINEE_REQUEST:
      newState.requestType = constants.UPDATE_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.UPDATE_TRAINEE_SUCCESS:
      newState.requestType = action.type;
      newState.requestSuccess = true;
      newState.trainee = action.body;
      return newState;
    case constants.UPDATE_TRAINEE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.UPDATE_DUPLICATE_TRAINEE_REQUEST:
      newState.requestType = constants.UPDATE_DUPLICATE_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.UPDATE_DUPLICATE_TRAINEE_SUCCESS:
      newState.requestType = action.type;
      newState.trainee = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.UPDATE_DUPLICATE_TRAINEE_FAILURE:
      newState = defaultState;
      return newState;
    case constants.ARCHIVE_TRAINEE_REQUEST:
      newState.requestType = constants.ARCHIVE_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.ARCHIVE_TRAINEE_SUCCESS:
      newState.requestType = action.type;
      newState.requestSuccess = action.body.result;
      return newState;
    case constants.ARCHIVE_TRAINEE_FAILURE:
      newState = defaultState;
      return newState
    case constants.UNARCHIVE_TRAINEE_REQUEST:
      newState.requestType = constants.UNARCHIVE_TRAINEE_REQUEST;
      newState.requestSuccess = false;
      return newState;
    case constants.UNARCHIVE_TRAINEE_SUCCESS:
      newState.requestType = action.type;
      newState.requestSuccess = action.body.result;
      return newState;
    case constants.UNARCHIVE_TRAINEE_FAILURE:
      newState = defaultState;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/trainees.js